import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/transaction-report",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const userListing = require("./TransactionWiseReport").default;
          cb(null, userListing);
        },
        "TransactionReports"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/TransactionWiseReport/index.js